module.exports = __webpack_public_path__ + "img/modules.3b3bd389.svg";